import React from 'react';
import Context from './context';
import AppTypography from '../../core/Typography/AppTypography';
import HighlightImage from '../../../images/features/jtb/highlight.png';

const Intro = () => {
  const { classes } = React.useContext(Context);

  return (
    <div>
      <div className={classes.highlight}>
        <AppTypography
          size={22}
          mb={3}
          ml={2}
          mr={2}
          weight="bold"
          align="center"
          position="relative"
          color="palette.text.primary"
        >
          <span>
            ふるさと納税の産地へ行って返礼品がどのように作られてるか知ろう！
          </span>
          <img src={HighlightImage} className="highlight" />
        </AppTypography>
      </div>
      <AppTypography
        display="flex"
        justifyContent="center"
        lineHeight={1.8}
        color="palette.text.primary"
      >
        ふるさと納税を行うJTBのふるぽと連携して、返礼品がどのように作られてるか、産地の裏側をお手伝いをしながら知れる新しい旅を提供開始
      </AppTypography>
      <AppTypography
        display="flex"
        justifyContent="center"
        lineHeight={1.8}
        color="palette.text.primary"
      >
        ふるさと納税を利用して地域を応援するだけでなく、おてつたびで実際に産地を訪れて、さらに地域の魅力を発見してみてください。
      </AppTypography>
    </div>
  );
};

export default Intro;
